import layout from 'store/reducers/layout';
import user from 'store/reducers/user';
import subscription from 'store/reducers/subscription';
import system from 'store/reducers/system';
import account from 'store/reducers/account';
import { combineReducers } from 'redux';

export {
  user,
  subscription,
  layout,
  system,
  account,
};

export default combineReducers({
  ...user,
  ...subscription,
  ...layout,
  ...system,
  ...account,
});
